<template>
  <div :class="[`nav-theme-${navTheme}`, `nav-layout-${navLayout}`]">
    <a-layout id="components-layout-custom-trigger" style="min-height: 100vh">
      <a-layout-sider
        v-if="navLayout === 'left'"
        :theme="navTheme"
        :trigger="null"
        collapsible
        v-model="collapsed"
        width="208px"
      >
        <div class="logo"><icon-font type="icon-logo" width="10" height="4"></icon-font></div>
        <SiderMenu />
      </a-layout-sider>
<!--      <a-layout-sider width="208px"></a-layout-sider>-->
      <a-layout :style="autoHeight">
        <a-layout-header style="background: #fff; padding: 0;height:48px">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="collapsed = !collapsed"
          ></a-icon>
          <Header />
        </a-layout-header>
        <!-- 面包屑 -->
        <div class="breadcrumb-container">
          <a-breadcrumb :routes="routes" style="background-color: #f0f2f5; padding: 10px 0;" separator=">">
            <template slot="itemRender" slot-scope="{ route, params, routes, paths }">
              <span v-if="routes.length === 1">
                {{ route.meta.messageKey ? $t(route.meta.messageKey) : route.meta.title }}
              </span>
              <router-link v-else :to="`${route.path}`">
                {{ route.meta.messageKey ? $t(route.meta.messageKey) : route.meta.title }}
              </router-link>
            </template>
          </a-breadcrumb>
        </div>
        <a-layout-content style="margin: 16px 16px" >
          <transition>
            <router-view/>
          </transition>
        </a-layout-content>
        <a-layout-footer style="text-align: center;position: fixed;bottom: 0px;width: 100%;padding: 5px 50px;z-index:99999999;" >
          <Footer />
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import SiderMenu from './SiderMenu'
import request from '../utils/request'
import Icon from 'ant-design-vue/es/icon'
import AES from '@ali/aes-tracker'
// 引入插件
import {switchPage} from '@ali/aes-tracker-plugin-pv'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2733048_pwsnsjh4bsb.js'
})
export default {
  data () {
    return {
      collapsed: false,
      routes: [],
      height: 1000,
      autoHeight: {
        overflow: 'auto',
        height: '100px',
        margin: '0 0 100px 0'
      }
    }
  },
  computed: {
    navTheme () {
      return this.$route.query.navTheme || 'dark'
    },
    navLayout () {
      return this.$route.query.navLayout || 'left'
    }
  },
  components: { Header, Footer, SiderMenu, IconFont },
  created () {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
    this.routes = this.$route.matched.filter(item => item.meta.title)
    this.getLoginStatus()
    this.getUserInfo()
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight () {
      this.autoHeight.height = parseInt(window.outerHeight) + 'px'
    },
    getLoginStatus () {
      request({
        url: '/authorization/loginStatus',
        method: 'get'
      }).then(response => {
        console.log(response.data)
      })
    },
    getUserInfo () {
      request({
        url: '/user/info',
        method: 'get'
      }).then(response => {
        console.log('userInfo', response.data)
        if (response.data.success) {
          AES.setConfig('uid', response.data.model.uid)
          AES.setConfig('username', response.data.model.userName)
        }
        console.log('AES_CONFIG', AES.getConfig())
      })
    }
  },
  watch: {
  // 监听路由变化
    $route (e) {
      this.routes = e.matched.filter(items => items.meta.title)
      this.selectedKeys = [e.path]
      // 单页应用切换页面后发送PV埋点：
      switchPage()
    }
  }
}
</script>

<style scoped>
.trigger {
  padding: 0 20px;
  line-height: 48px;
  font-size: 20px;
}
.trigger:hover {
  background: #eeeeee;
}
.logo {
  height: 64px;
  line-height: 64px;
  text-align: center;
  overflow: hidden;
  font-size: larger;
}
.nav-theme-dark >>> .logo {
  color: #ffffff;
}
.breadcrumb-container{
  margin: 5px 0 0 0;
  background-color: rgb(255 255 255);
  min-height: 40px;
}
.breadcrumb-container >>> .ant-breadcrumb{
  background-color: rgb(255 255 255) !important;
  padding: 10px 10px 0px 20px !important;

}
.logo >>> .anticon {
  margin-top: -55px;
  font-size: 170px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/BasicLayout.vue